import React, {useEffect} from 'react'
import './Navbar.css'
import {NavLink} from 'react-router-dom'

const Navbar = () => {

    window.addEventListener('scroll', function() {
        let navbar = document.querySelector('.nav-bar');
        let scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollPosition > 100) {
            navbar.classList.add('fixed-style');
        } else {
            navbar.classList.remove('fixed-style');
        }
    })
    
  return (
    <div>
        <div className='row nav-bar fixed-top'>
            <NavLink className="col-7 d-flex justify-content-center align-items-end" style={{textDecoration:"none", color:"white"}} to={"/Progetti"}>
                <h1 className="logo-style nav-btn">Progetti4C</h1> 
            </NavLink>

            <NavLink className="col-5 d-flex justify-content-center align-items-end" style={{textDecoration:"none", color:"white"}} to={"/"}>
                <h5 className='nav-btn'>Home</h5>
            </NavLink>
        </div>
    </div>
  )
}

export default Navbar